<template>
  <div>
    <!-- This is used to reset the tabindex position on every route change for accessibilty -->
    <div ref="focus" tabindex="-1"></div>
    <a class="skip-main ontario-button ontario-button--primary" href="#main" tabindex="0">{{ $t("header_skip") }}</a>
    <div id="header">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-4">
            <router-link :to="{ name: 'home', params: { lang: currentLanguageAcronym } }"><img :src="$vueAssets + 'logo.png'" :alt="$t('header_logo_accessibility')"></router-link>
          </div>
          <div class="col-md-6 col-8 right_head">
            <a :href="subscription + currentLanguageAcronym + '/signup'" class="text-white float-right no_btn a_no_line">{{ $t("header_subscribe") }}</a>
            <!-- Treat legacy links as shortlinks for the purpose of the language toggle. This is to bypass tracking acronyms that differ between English and French -->
            <div v-if="routeName == 'ministry'">
              <router-link class="text-white a_no_line float-right mr-3" :to="{ name: this.$route.name, params: { lang: oppositeLanguageAcronym, acronym: oppositeMinistryAcronym } }" v-on:click.native="refetchData()">{{ oppositeLanguageTitle }}</router-link>
            </div>
            <div v-else-if="!hideLanguageToggle">
              <router-link class="text-white a_no_line float-right mr-3" :to="{ name: this.$route.name, params: { lang: oppositeLanguageAcronym, type: releaseType, release_id: currentLanguageId, slug: releaseSlug } }" v-on:click.native="refetchData()">{{ oppositeLanguageTitle }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div><!-- header -->

    <div class="clearfix"></div>

    <div id="sub_head" class="mt-0 mb-4">

      <div class="container">
        <div>
          <div id="title-menu" class="row">
            <div class="col-md-6 col-6">
                <router-link :to="{ name:'home', params: { lang: currentLanguageAcronym } }" class="text-white"><h1 class="float-left mt-4 h4">{{ $t("header_newsroom") }}</h1></router-link>
            </div>
            <div class="col-md-6 col-6 text-right">
              <div class="row">
                <div class="col-lg-4 offset-lg-5 text-right pr-0">
                  <router-link :to="{ name:'search', params: { lang: currentLanguageAcronym } }" class="text-white" id="search_head">
                    <p class="float-right mr-0" id="search-center">{{ $t("header_search") }}</p>
                    <img id="search_icon" class="float-right" :src="$vueAssets + 'magnify.png'" :alt="$t('header_search_accessibility')">
                  </router-link>
                </div>
                <div class="col-lg-3 text-right">
                    <div class="dropdown">
                      <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img :src="$vueAssets + 'Vector.png'" :alt="$t('header_menu_accessibility')"><span class="ml-2" id="menu-title">{{ $t("header_menu") }}</span>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right main_menu" aria-labelledby="dropdownMenuButton">
                          <router-link :to="{ name:'releases', params: { lang: currentLanguageAcronym } }" class="list-group-item list-group-item-action">{{ $t("menu_releases") }}</router-link>
                          <router-link :to="{ name:'advisories', params: { lang: currentLanguageAcronym } }" class="list-group-item list-group-item-action">{{ $t("menu_advisories") }}</router-link>
                          <router-link :to="{ name:'bulletins', params: { lang: currentLanguageAcronym } }" class="list-group-item list-group-item-action">{{ $t("menu_bulletins") }}</router-link>
                          <router-link :to="{ name:'media', params: { lang: currentLanguageAcronym } }" class="list-group-item list-group-item-action">{{ $t("menu_media") }}</router-link>
                          <!-- <router-link :to="{ name:'timeline', params: { lang: currentLanguageAcronym } }" class="list-group-item list-group-item-action">{{ $t("menu_timeline") }}</router-link> -->
                          <router-link :to="{ name:'search', params: { lang: currentLanguageAcronym } }" id="search_menu" class="list-group-item list-group-item-action">{{ $t("menu_search") }}</router-link>
                      </div><!-- dropdown menu -->
                    </div> <!-- dropdown -->
                  </div>
                </div>
            </div><!-- col-md-6 -->
          </div><!-- title-menu -->
        </div> <!--div -->
        <div class="clearfix"></div>
      </div><!-- container -->

    </div><!-- sub_head -->

    <main id="main">
      <div>
        <notification ref="notification"></notification>
        <button v-on:click="topFunction()" class="d-print-none" id="scroll_top_btn" :title="$t('body_top_accessibility')" ><img :src="$vueAssets + 'scrollTop.png'" alt="upwards arrow"></button>
        <router-view :key="$route.path"/>
      </div>
    </main>

    <footer class="ontario-footer ontario-footer--default">
      <div class="row container">
          <div class="col-7">
              <ul class="ontario-footer__links-container ontario-footer__links-container--inline">
                  <li><a class="ontario-footer__link" :href="$t('footer_accessibility_link')">{{ $t("footer_accessibility") }}</a></li>
                  <li><a class="ontario-footer__link" :href="$t('footer_privacy_link')">{{ $t("footer_privacy") }}</a></li>
                  <li><a class="ontario-footer__link" :href="$t('footer_contact_link')">{{ $t("footer_contact") }}</a></li>
              </ul>
              <div class="ontario-footer__copyright ml-4">
                  <a class="ontario-footer__link ml-3" :href="$t('footer_printer_link')">&copy; {{ $t("footer_printer") }}, <span class="ontario-nbsp">2012-{{ year }}</span></a>
              </div>
          </div>
      </div>
    </footer>
    <!-- footer -->

  </div>
</template>

<script>
import Notification from './components/Notification.vue'

export default {
  name: 'App',

  components: {
    Notification
  },
  // This is a function used by the vue-meta plugin
  metaInfo () {
    return {
      meta: [
        { vmid: 'keywords', name: 'keywords', content: (this.$route.meta.title ? this.$route.meta.title[this.currentLanguageAcronym] : null) },
        { vmid: 'description', name: 'description', content: (this.$route.meta.title ? this.$route.meta.title[this.currentLanguageAcronym] : null) }
      ]
    }
  },

  data () {
    return {
      currentLanguageId: 0,
      oppositeMinistryAcronym: null,
      releaseSlug: null,
      releaseType: null,
      menuBar: true, // header
      searchBar: false, // header
      year: new Date().getFullYear(), // footer
      subscription: process.env.VUE_APP_SUBSCRIPTION,
      hideLanguageToggle: false,
    }
  },
  computed: {
    currentLanguageAcronym () {
      return this.$root.$i18n.locale.toLowerCase()
    },
    oppositeLanguageAcronym () {
      return (this.$root.$i18n.locale.toLowerCase() == 'en') ? 'fr' : 'en'
    },
    oppositeLanguageTitle () {
      return (this.$root.$i18n.locale.toLowerCase() == 'en') ? 'Français' : 'English'
    },
    rssUrl () {
      let rssLang = (this.$root.$i18n.locale) ? this.$root.$i18n.locale : this.$root.$i18n.locale.toLowerCase()
      return window.location.origin + '/newsroom/' + rssLang + '/' + 'rss/allnews.rss'
    },
    routeName () {
      return this.$route.name
    },
  },
  methods: {
    toggleSearch () {
      this.searchBar = !this.searchBar,
      this.menuBar = !this.menuBar
    },
    refetchData () {
      this.$refs.notification.getNotification()
    },
    setScroll () {
      // this method listens for the user to scroll the page to show a scroll to top button
      var mybutton = document.getElementById('scroll_top_btn')
      window.onscroll = function () { scrollFunction() }
      function scrollFunction () {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
          mybutton.style.display = 'block'

        } else {
          mybutton.style.display = 'none'
        }

        if (window.innerHeight + window.scrollY > document.body.clientHeight - 120) {
          document.getElementById('scroll_top_btn').style.backgroundColor = '#f2f2f2'
        } else {
          document.getElementById('scroll_top_btn').style.backgroundColor = '#fff'
        }
      }
    },
    topFunction () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
    
  },

  watch: {
    // watch for route changes
    $route (to, from) {
      // on every route change, reset the tab focused element (this is for accessibility)
      this.$refs.focus.focus()
      // The language toggle can be hidden if a release is not published in both languages
      // Failure to reset after route change can result in the language toggle staying hidden
      this.hideLanguageToggle = false
    }
  },
  mounted () {
    // Reset bilingual id
    this.currentLanguageId = 0
    // Get bilingual id from release component
    this.$root.$on('setBilingualData', (releaseType, id, slug) => {
      this.releaseType = releaseType
      this.currentLanguageId = id
      this.releaseSlug = slug
    })
    this.$root.$on('seti18nLanguage', (releaseLanguage) => {
      this.$root.$i18n.locale = releaseLanguage
      this.refetchData()
    })
    this.$root.$on('setOppositeMinistryAcronym', (acronym) => {
      this.oppositeMinistryAcronym = acronym
    })
    this.$root.$on('hideLanguageToggle', (value) => {
      this.hideLanguageToggle = true
    })
    this.setScroll()
   
  }
}

</script>
